import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '@app/shared/header/header.component';
import { FooterComponent } from '@app/shared/footer/footer.component';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-portal-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent],
  templateUrl: './portal-layout.component.html',
  styleUrl: './portal-layout.component.scss',
})
export class PortalLayoutComponent implements OnInit {
  private readonly router = inject(Router);
  showFooter: boolean = true;

  ngOnInit(): void {
    this.checkFooterVisibility(this.router.url);
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.checkFooterVisibility(event.urlAfterRedirects || event.url);
      });
  }

  private checkFooterVisibility(url: string): void {
    if (!url) {
      this.showFooter = true;
      return;
    }
    const cleanUrl = url.split('?')[0].split('#')[0].toLowerCase();

    // Oculta completamente o footer em toda a área reservada ao utilizador
    const isUserArea =
      cleanUrl.startsWith('/dashboads') ||
      cleanUrl.startsWith('/dashboard') ||
      cleanUrl.startsWith('/perfil');

    this.showFooter = !isUserArea;
  }
}
